module.exports = __webpack_public_path__ + "img/9788956372556.033c48d6.jpg";